import { NgFor } from '@angular/common';
import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AboutUs } from '../../components/about-us/about-us';
import { Projects } from '../../components/projects/projects';
import { Reviews } from '../../components/reviews/reviews';
import { Services } from '../../components/services/services';
import { HOME_SECTIONS } from '../../data/home-sections';
import { ScrollSpyService } from '../../services/scroll-spy.service';

@Component({
  selector: 'app-home',
  imports: [NgFor, RouterLink, AboutUs, Services, Projects, Reviews],
  templateUrl: './home.html',
  styleUrl: './home.css',
})
export class Home implements AfterViewInit, OnDestroy {
  readonly sections = HOME_SECTIONS;
  readonly heroMilestones = [
    { label: 'Ventures in portfolio', target: 5, suffix: '+', displayValue: '5+' },
    { label: 'High-growth verticals', target: 4, suffix: '', displayValue: '4' },
    { label: 'Operators & specialists', target: 120, suffix: '+', displayValue: '120+' },
    { label: 'Shared build playbooks', target: 25, suffix: '+', displayValue: '25+' },
  ];

  constructor(
    public readonly scrollSpy: ScrollSpyService
  ) {}

  ngAfterViewInit(): void {
    this.scrollSpy.observeSections(['hero', ...this.sections.map((section) => section.id)]);

    const pending = this.scrollSpy.consumePendingSection();
    if (pending) {
      setTimeout(() => this.scrollSpy.scrollTo(pending), 0);
    }

    if (this.scrollSpy.consumePendingScrollTop()) {
      setTimeout(() => window.scrollTo({ top: 0, left: 0, behavior: 'auto' }), 0);
    }
  }

  ngOnDestroy(): void {
    this.scrollSpy.disconnect();
  }

  scrollTo(id: string): void {
    this.scrollSpy.scrollTo(id);
  }
}
